import { EventsOfTask } from 'pages/Tasks/types'
import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'
import { getCommentButton } from 'redesign/components/templates/task-details-action-buttons/utils/get-comment-button'
import { getAcceptAbsenceButton } from './get-accept-absence-button'
import { getRejectAbsenceButton } from './get-reject-absence-button'
import { getShowBalanceButton } from './get-show-balance-button'
import { getShowTeamplanButton } from './get-show-teamplan-button'

export const getOfficePendingActionButtons = (props: ResolveActionButtonsProps) => {
  const {
    task,
    t,
    canSendComment,
    sendEvent,
    refetch,
    setMessageDrawerProps,
    openForm,
    displayTeamPlanButton,
    handleButtonAction,
  } = props
  const taskHasTimeline = Boolean(task.timeline?.length)

  return [
    getAcceptAbsenceButton({ t, openForm }),
    ...(taskHasTimeline && canSendComment
      ? [
          getCommentButton({
            t,
            sendEvent,
            refetch,
            setMessageDrawerProps,
            taskEvent: EventsOfTask.absenceRequestSendCommentToFrontline,
          }),
        ]
      : []),
    ...(displayTeamPlanButton ? [getShowTeamplanButton({ handleButtonAction, t })] : []),
    getShowBalanceButton(props),
    getRejectAbsenceButton(props),
  ]
}
